/**
 * Returns CSS class string with `autoFill` appended when the field was
 * populated from the API. Keeps styling consistent across all step components
 * without per-field hardcoding.
 */
export function autoFillClass(
  field: string,
  prefilledFields: Set<string>,
  base = "fi",
): string {
  return prefilledFields.has(field) ? `${base} autoFill` : base;
}

/**
 * Returns `{ readOnly: true }` for prefilled fields, empty object otherwise.
 * Spread onto any <input> or <textarea> to block user edits while keeping
 * Formik values intact for submission.
 */
export function prefillProps(
  field: string,
  prefilledFields: Set<string>,
): { readOnly?: true } {
  return prefilledFields.has(field) ? { readOnly: true } : {};
}

/**
 * Returns a noop onChange for prefilled <select> fields.
 * (readOnly is not a valid select attribute; a noop onChange discards
 * selection changes while Formik still submits the original value.)
 */
export function prefillSelectProps(
  field: string,
  prefilledFields: Set<string>,
): { onChange?: React.ChangeEventHandler<HTMLSelectElement> } {
  return prefilledFields.has(field) ? { onChange: () => {} } : {};
}
